import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { produce } from 'immer'

import { FacebookCategory, FacebookPage, MediaFileMetadata } from '@3m5/sm_publish-frontend-api/models'

import { ApiError } from '../facebookSettingsRoot.reducer'

import {
  getAllFacebookCategories,
  getPotentialPageImprint,
  getFacebookPage,
  saveFacebookPageInformation,
  uploadMediaFile,
  updateCoverImage,
  updateProfileImage,
  listMediaFiles,
  uploadProfileMediaFile,
  uploadCoverMediaFile,
  listCoverImages,
  listProfileImages,
} from './facebook.actions'

export interface FacebookState {
  fetching: boolean
  facebookPage?: FacebookPage
  potentialImprint?: string
  mediaFileMetadata?: MediaFileMetadata
  profileMediaFile?: MediaFileMetadata
  coverMediaFile?: MediaFileMetadata
  mediaFiles?: MediaFileMetadata[]
  coverImages?: MediaFileMetadata[]
  profileImages?: MediaFileMetadata[]
  categories?: Array<FacebookCategory>
  updateImprintAutomatically: boolean
  error: ApiError
}

const INITIAL_STATE: FacebookState = {
  fetching: false,
  updateImprintAutomatically: false,
  error: {},
}

export const facebookReducer = reducerWithInitialState(INITIAL_STATE)
/**
   * getFacebookPage
   */
  .case(getFacebookPage.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getFacebookPage
    })
  })

  .case(getFacebookPage.done, (state, { result }) => {
    return produce(state, draft => {
      draft.facebookPage = result
      draft.updateImprintAutomatically = result.updateImprintAutomatically || false
      draft.fetching = false
    })
  })

  .case(getFacebookPage.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getFacebookPage = (error as Response)
    })
  })

/**
   * saveFacebookPageInformation
   */
  .case(saveFacebookPageInformation.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.saveFacebookPageInformation
    })
  })

  .case(saveFacebookPageInformation.done, (state) => {
    return produce(state, draft => {
      draft.fetching = false
    })
  })

  .case(saveFacebookPageInformation.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.saveFacebookPageInformation = (error as Response)
    })
  })

/**
   * getPotentialPageImprint
   */
  .case(getPotentialPageImprint.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getPotentialPageImprint
    })
  })

  .case(getPotentialPageImprint.done, (state, { result }) => {
    return produce(state, draft => {
      draft.potentialImprint = result
      draft.fetching = false
    })
  })

  .case(getPotentialPageImprint.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getPotentialPageImprint = (error as Response)
    })
  })

/**
   * getAllFacebookCategories
   */
  .case(getAllFacebookCategories.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getAllFacebookCategories
    })
  })

  .case(getAllFacebookCategories.done, (state, { result }) => {
    return produce(state, draft => {
      draft.categories = result.categories
      draft.fetching = false
    })
  })

  .case(getAllFacebookCategories.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getAllFacebookCategories = (error as Response)
    })
  })

/**
   * uploadMediaFile
   */
  .case(uploadMediaFile.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.uploadMediaFile
    })
  })

  .case(uploadMediaFile.done, (state, { result }) => {
    return produce(state, draft => {
      draft.mediaFileMetadata = result
      draft.fetching = false
    })
  })

  .case(uploadMediaFile.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.uploadMediaFile = (error as Response)
    })
  })

/**
   * updateCoverImage
   */
  .case(updateCoverImage.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.uploadMediaFile
    })
  })

  .case(updateCoverImage.done, (state) => {
    return produce(state, draft => {
      draft.fetching = false
    })
  })

  .case(updateCoverImage.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.uploadMediaFile = (error as Response)
    })
  })

/**
   * updateProfileImage
   */
  .case(updateProfileImage.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.uploadMediaFile
    })
  })

  .case(updateProfileImage.done, (state) => {
    return produce(state, draft => {
      draft.fetching = false
    })
  })

  .case(updateProfileImage.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.uploadMediaFile = (error as Response)
    })
  })

/**
   * listMediaFiles
   */
  .case(listMediaFiles.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.listMediaFiles
    })
  })

  .case(listMediaFiles.done, (state, { result }) => {
    return produce(state, draft => {
      draft.mediaFiles = result
      draft.fetching = false
    })
  })

  .case(listMediaFiles.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.listMediaFiles = (error as Response)
    })
  })

/**
   * listCoverImages
   */
  .case(listCoverImages.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.listCoverImages
    })
  })

  .case(listCoverImages.done, (state, { result }) => {
    return produce(state, draft => {
      draft.coverImages = result
      draft.fetching = false
    })
  })

  .case(listCoverImages.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.listCoverImages = (error as Response)
    })
  })

/**
   * listProfileImages
   */
  .case(listProfileImages.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.listProfileImages
    })
  })

  .case(listProfileImages.done, (state, { result }) => {
    return produce(state, draft => {
      draft.profileImages = result
      draft.fetching = false
    })
  })

  .case(listProfileImages.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.listProfileImages = (error as Response)
    })
  })

/**
   * uploadProfileMediaFile
   */
  .case(uploadProfileMediaFile.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.uploadTemporaryMediaFile
    })
  })

  .case(uploadProfileMediaFile.done, (state, { result }) => {
    return produce(state, draft => {
      draft.profileMediaFile = result
      draft.fetching = false
    })
  })

  .case(uploadProfileMediaFile.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.uploadTemporaryMediaFile = (error as Response)
    })
  })

/**
   * uploadCoverMediaFile
   */
  .case(uploadCoverMediaFile.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.uploadTemporaryMediaFile
    })
  })

  .case(uploadCoverMediaFile.done, (state, { result }) => {
    return produce(state, draft => {
      draft.coverMediaFile = result
      draft.fetching = false
    })
  })

  .case(uploadCoverMediaFile.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.uploadTemporaryMediaFile = (error as Response)
    })
  })
